import { CalendarPlus, X } from "lucide-react";
import { downloadIcs, googleCalUrl } from "@/lib/calendar";

export const AddToCalendar = ({ event, teamName }) => (
  <div className="flex flex-wrap gap-2" data-testid="add-to-calendar">
    <button className="btn-ghost !min-h-[44px] !text-base" data-testid="add-calendar-ics-button" onClick={() => downloadIcs(event, teamName)}>
      <CalendarPlus size={18} /> Add to calendar
    </button>
    <a className="btn-ghost !min-h-[44px] !text-base" data-testid="add-calendar-google-link" href={googleCalUrl(event, teamName)} target="_blank" rel="noreferrer">
      Google
    </a>
  </div>
);

const Names = ({ slot, onRemove }) => {
  if (!onRemove || !slot.names.length) return <p className="text-sm font-medium text-[var(--muted)] truncate" data-testid="slot-names">{slot.names.join(", ") || "Open"}</p>;
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid="slot-names">
      {slot.names.map((n) => (
        <button key={n} className="name-chip" data-testid="slot-name-remove" aria-label={`Remove ${n}`} onClick={() => onRemove(slot, n)}>{n} <X size={12} /></button>
      ))}
    </div>
  );
};

export const SlotList = ({ slots, me, onSign, onCancel, onRemove, extra, detail, title = "Signups", testId = "event-slots" }) => (
  <div className="space-y-1.5" data-testid={testId}>
    <span className="ctl-label">{title}</span>
    {slots.map((s) => {
      const mine = me && s.names.some((n) => n.toLowerCase() === me.toLowerCase());
      const full = s.names.length >= s.capacity;
      return (
        <div key={s.id} className="slot-row" data-testid={`slot-${s.id}`}>
          <div className="min-w-0 flex-1">
            <p className="font-bold">{s.label} <span className="text-[var(--muted)] font-mono text-xs">{s.names.length}/{s.capacity}</span></p>
            {s.description && <p className="text-xs font-medium text-[var(--muted)]" data-testid="slot-description">{s.description}</p>}
            <Names slot={s} onRemove={onRemove} />
            {detail && <div className="mt-1">{detail(s)}</div>}
          </div>
          {extra && extra(s)}
          {onSign && (mine ? (
            <button className="btn-ghost !min-h-[44px] !text-sm" data-testid="slot-cancel-button" onClick={() => onCancel(s)}>Remove me</button>
          ) : (
            <button className="btn-primary !min-h-[44px] !text-sm" data-testid="slot-signup-button" disabled={!me || full} onClick={() => onSign(s)}>
              {full ? "Full" : "Sign up"}
            </button>
          ))}
        </div>
      );
    })}
  </div>
);
